import { render, staticRenderFns } from "./syswechatconfig.vue?vue&type=template&id=535fcb45&scoped=true&"
import script from "./syswechatconfig.vue?vue&type=script&lang=js&"
export * from "./syswechatconfig.vue?vue&type=script&lang=js&"
import style1 from "./syswechatconfig.vue?vue&type=style&index=1&id=535fcb45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535fcb45",
  null
  
)

export default component.exports